import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Form, message } from 'antd';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { PageContext } from '../../../lib/context';
import mutations from '../../../utils/gql/mutations';
import queries from '../../../utils/gql/queries';
import SettingsView from './settings';
import philippines from '../../../assets/philippines.json';

interface Settings {
  id: number;
  disconnection: Date;
  sending_to_customers: Date;
  deadline: Date;
  cutoff: Date;
  created_at: Date;
  updated_at: Date;
}

interface SettingsUpdate {
  disconnection: Date;
  sending_to_customers: Date;
  deadline: Date;
  cutoff: Date;
}

const SettingsController = () => {
  const [form] = Form.useForm();
  const [settings, setSettings] = useState<Settings[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [provinces, setProvinces] = useState([]);

  const [updateSettings] = useMutation<SettingsUpdate>(
    mutations.UPDATE_SETTINGS,
    {
      onCompleted(res) {
        message.success('Settings updated successfully.');
        _getSettings();
      },
      onError({ graphQLErrors }) {
        console.log(graphQLErrors);
        message.error('Something is wrong');
        // message.error('Duplicate ID number.');
      },
    }
  );

  const [getSettings, { data }] = useLazyQuery(queries.GET_SETTINGS, {
    fetchPolicy: 'no-cache',
  });

  const _submitHandler = (data: any) => {
    form.submit();
    form.setFieldsValue(data);
  };

  const _showEditHandler = (data: any) => {
    return () => {
      // form.setFieldsValue(data);
      // _showHandler();
    };
  };

  const _onFinish = (data: SettingsUpdate) => {
    updateSettings({
      variables: {
        id: 1,
        data,
      },
    });
  };

  const _getSettings = () => {
    getSettings();
  };

  useEffect(() => {
    _getSettings();
  }, [getSettings]);

  const _showHandler = () => setShow(true);
  const _closeHandler = () => setShow(false);

  const getKeyValue =
    <T extends object, U extends keyof T>(obj: T) =>
      (key: U) =>
        obj[key];

  const _regionHandler = (val: any) => {
    form.setFieldsValue({ province: null });
    let provinces: any = getKeyValue(philippines)(val);
    provinces = Object.keys(provinces.province_list).map(k => ({
      value: k,
      label: k,
    }));
    setProvinces(provinces);
  };

  useEffect(() => {
    form.setFieldsValue({ ...data?.settings?.[0] });
  }, [data]);

  const value: object = {
    form,
    show,
    philippines,
    provinces,
    _regionHandler,
    _showHandler,
    _closeHandler,
    _submitHandler,
    _onFinish,
  };

  return (
    <PageContext.Provider value={value}>
      <SettingsView />
    </PageContext.Provider>
  );
};

export default SettingsController;
